export default {
	'slider': 'SliderPartial',
	'small_image_select': 'ImageSelectPartial',
	'large_image_select': 'ImageSelectPartial',
	'binary': 'BinaryPartial',
	'box_select': 'BoxSelectPartial',
	'radio': 'RadioPartial',
	'select': 'SelectPartial',
	'scroller': 'ScrollerPartial',
	'star': 'StarPartial',
	'text': 'TextResponsePartial',
	'multi_question': 'MultiQuestionPartial',
	'long_text_bubble': 'LongTextBubblePartial',
	'date': 'DatePartial',
	'unit': 'UnitPartial',
	'image_upload': 'ImageUploadPartial',
	'human_map': 'HumanMapPartial',
	'query': 'QueryPartial',
	'video': 'VideoPartial'
}